define.alias("checkout/components/payment", "settings/components/payment");